import { GiveawayContributionApiClient } from '@fourthwall/services/dist/GiveawayContributionApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'

export const useGiveawayContributionQuery = createQueryHook(
  GiveawayContributionApiClient.getGiveawayContribution,
  {
    queryKey: ['giveawayContribution'],
    select: (data) => {
      data.offer.productName = decodeHtmlEntities(data.offer.productName)

      return data
    },
  },
)
